<template>
  <div>
    <!-- TABLE HISTORIQUE -->
    <div class="content">
      <div class="block">
        <div class="block-content block-content-full">
          <table class="table table-striped table-vcenter table-bordered">
            <thead>
              <tr>
                <th>Date</th>
                <th>Type</th>
                <th>N° de facture</th>
                <th>Montant HT</th>
                <th>Montant TTC</th>
                <th class="text-center">Voir</th>
                <th class="text-center">Actions</th>
              </tr>
            </thead>

            <tbody>
              <tr v-for="invoice in invoices" :key="invoice.id">
                <!-- date -->
                <td>{{ formatDate(invoice.created_at) }}</td>
                <!-- Type -->
                <td>
                    <span v-if="invoice.type === 'invoice'" class="badge bg-success-light text-success rounded-pill">Facture</span>
                    <span v-else-if="invoice.type === 'deposit'" class="badge bg-success-light text-success rounded-pill">Acompte</span>
                    <span v-else-if="invoice.type === 'credit_note'" class="badge bg-primary rounded-pill">Avoir</span>
                </td>
                <!-- Invoice number -->
                 <td>
                    {{ invoice.serial_number}}
                </td>
                <!-- HT amount -->
                <td>
                  {{ formatPrice(invoice.total_ht) }}
                </td>
                <!-- TTC Amount -->
                 <td>
                  {{ formatPrice(invoice.total_ttc) }}
                </td>
                <!-- open -->
                <td class="text-center">
                    <v-btn
                        small
                        outlined
                        color="warning"
                        @click="openInvoice(invoice)"
                    >
                        Voir
                    </v-btn>
                </td>
                <td class="text-center">
                    <v-btn
                        v-if="canCancelForCorrection(invoice)"
                        small
                        outlined
                        color="error"
                        :loading="cancellingInvoiceId === invoice.id"
                        @click="openCancelDialog(invoice)"
                    >
                        Annuler et refaire
                    </v-btn>
                </td>
                </tr>

              <tr v-if="!invoices.length">
                <td colspan="7" class="text-center text-muted w-100">
                  Aucune factures
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <v-dialog
      v-model="cancelDialog"
      max-width="800"
      persistent
      overlay-color="black"
      overlay-opacity="0.5"
      transition="invoice-cancel-slide-y-transition"
    >
      <v-card class="invoice-cancel-modal">
        <div class="modal-header invoice-cancel-modal__header">
          <h5 class="modal-title mb-0">
            Annuler et refaire — {{ selectedCancelInvoice ? selectedCancelInvoice.serial_number : '' }}
          </h5>
          <button type="button" class="btn-close" :disabled="cancelLoading" @click="closeCancelDialog"></button>
        </div>

        <div v-if="selectedCancelInvoice" class="modal-body invoice-cancel-modal__body">
          <div class="invoice-cancel-modal__summary mb-3">
            <div>
              <div class="text-muted small">Facture à annuler</div>
              <div class="fw-semibold">{{ selectedCancelInvoice.serial_number }}</div>
              <div class="text-muted small">{{ formatDate(selectedCancelInvoice.created_at) }}</div>
            </div>
            <span class="badge bg-success-light text-success rounded-pill">
              Acompte
            </span>
          </div>

          <div class="alert alert-warning mb-3">
            Un avoir total sera créé, les paiements liés seront remboursés par leur moyen d'origine, si besoin ouvrez le panier pour refaire l'encaissement.
          </div>

          <label class="form-label fw-semibold" for="cancel-invoice-note">Motif obligatoire</label>
          <textarea
            id="cancel-invoice-note"
            v-model="cancelNote"
            class="form-control"
            rows="3"
            maxlength="500"
            placeholder="Exemple : erreur de saisie du montant encaissé"
          ></textarea>
          <div class="d-flex justify-content-between mt-1">
            <small class="text-muted">Minimum 3 caractères</small>
            <small class="text-muted">{{ cancelNote.length }}/500</small>
          </div>

          <hr>

          <div class="d-flex justify-content-end">
            <table class="invoice-cancel-modal__totals">
              <tr class="text-muted">
                <td class="pe-4">Total HT annulé</td>
                <td class="text-end">{{ formatPrice(selectedCancelInvoice.total_ht) }}</td>
              </tr>
              <tr class="text-muted">
                <td class="pe-4">Total TVA annulé</td>
                <td class="text-end">{{ formatPrice(selectedCancelInvoice.total_tva) }}</td>
              </tr>
              <tr class="fw-bold border-top">
                <td class="pe-4 pt-1">Total avoir TTC</td>
                <td class="text-end text-danger pt-1">{{ formatPrice(selectedCancelInvoice.total_ttc) }}</td>
              </tr>
            </table>
          </div>

          <div v-if="cancelApiError" class="alert alert-danger mt-3 mb-0">
            {{ cancelApiError }}
          </div>
        </div>

        <div class="modal-footer invoice-cancel-modal__footer">
          <button type="button" class="btn btn-alt-secondary" :disabled="cancelLoading" @click="closeCancelDialog">
            Annuler
          </button>
          <button
            type="button"
            class="btn btn-primary"
            :disabled="!canConfirmCancel || cancelLoading"
            @click="confirmCancelForCorrection"
          >
            <span v-if="cancelLoading" class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
            Confirmer l'avoir
          </button>
        </div>
      </v-card>
    </v-dialog>

    <!-- DIALOG -->
    <v-dialog
      v-model="dialog"
      max-width="650"
      persistent
      overlay-color="black"
      overlay-opacity="0.5"
      transition="invoice-cancel-slide-y-transition"
    >
      <v-card class="invoice-cancel-modal">
        <div class="modal-header invoice-cancel-modal__header">
          <h5 class="modal-title mb-0">
            Correction d'erreur de saisie
          </h5>
          <button type="button" class="btn-close" :disabled="loading" @click="closeDialog"></button>
        </div>

        <div v-if="selected" class="modal-body invoice-cancel-modal__body">
          <div class="invoice-cancel-modal__summary mb-3">
            <div>
              <div class="text-muted small">Paiement original</div>
              <div class="fw-semibold">
                {{ selected.payment_method?.name || 'Non spécifié' }} — {{ formatPrice(selected.amount) }}
              </div>
              <div class="text-muted small">
                {{ formatDate(selected.created_at) }}
              </div>
            </div>
            <span class="badge bg-warning-light text-warning rounded-pill">
              Correction
            </span>
          </div>

          <div class="alert alert-warning mb-3">
            Cette correction annule le paiement saisi et recrée un mouvement avec la méthode et le montant corrigés.
          </div>

          <!-- Nouvelle méthode -->
          <label class="form-label fw-semibold">Nouvelle méthode de paiement</label>

          <v-select
            v-model="selectedMethod"
            :items="methods"
            item-text="name"
            item-value="id"
            label="Méthode"
            outlined
            dense
            prepend-inner-icon="mdi-credit-card"
            :loading="methodsLoading"
            :rules="[rules.required]"
            class="mt-2"
          />

          <!-- Montant -->
          <label class="form-label fw-semibold mt-1">Montant corrigé</label>
          <v-text-field
            v-model="amount"
            type="number"
            step="0.01"
            min="0.01"
            :max="selected.amount"
            outlined
            dense
            suffix="€"
            class="mt-3"
            :rules="[rules.required, rules.float, rules.positive, rules.maxSelectedAmount]"
          />

          <!-- Note -->
          <label class="form-label fw-semibold mt-1">Explication</label>
          <v-textarea
            v-model="note"
            placeholder="Exemple : erreur de saisie du montant encaissé"
            outlined
            dense
            rows="3"
            counter="500"
            class="mt-3"
            :rules="[v => !v || v.length <= 500 || 'Maximum 500 caractères']"
          />

          <div v-if="apiError" class="alert alert-danger mt-3 mb-0">
            {{ apiError }}
          </div>
        </div>

        <div class="modal-footer invoice-cancel-modal__footer">
          <button type="button" class="btn btn-alt-secondary" :disabled="loading" @click="closeDialog">
            Annuler
          </button>
          <button
            type="button"
            class="btn btn-primary"
            :disabled="!canSubmit || loading"
            @click="submit"
          >
            <span v-if="loading" class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
            Confirmer
          </button>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios"
import moment from "moment"
import "moment/locale/fr"

export default {
  props: {
    invoices: {
      type: Array,
      default: () => []
    },
    facInvoiceRoute: {
        type: String,
        default: ''
    }
  },

  data() {
    return {
      dialog: false,
      selected: null,

      methods: [],
      methodsLoading: false,
      selectedMethod: null,

      amount: null,
      note: "",

      loading: false,
      apiError: null,
      cancellingInvoiceId: null,
      cancelDialog: false,
      selectedCancelInvoice: null,
      cancelNote: "",
      cancelLoading: false,
      cancelApiError: null,

      rules: {
        required: v => !!v || "Champ requis",
        minCancelNote: v => (v && v.trim().length >= 3) || "Minimum 3 caractères",
        maxNote: v => !v || v.length <= 500 || "Maximum 500 caractères",
        float: v => {
          const n = parseFloat(v)
          return !isNaN(n) || "Montant invalide"
        },
        positive: v => parseFloat(v) > 0 || "Le montant doit être supérieur à 0",
        maxSelectedAmount: v => {
          const max = Math.abs(parseFloat(this.selected?.amount || 0))
          return parseFloat(v) <= max || `Maximum ${max.toFixed(2)} €`
        },
      }
    }
  },

  computed: {
    canSubmit() {
      return (
        this.selected &&
        this.selectedMethod &&
        this.amount !== null &&
        !isNaN(parseFloat(this.amount)) &&
        parseFloat(this.amount) > 0 &&
        parseFloat(this.amount) <= Math.abs(parseFloat(this.selected.amount))
      )
    },
    canConfirmCancel() {
      return this.selectedCancelInvoice
        && this.cancelNote
        && this.cancelNote.trim().length >= 3
        && this.cancelNote.length <= 500
    }
  },

  methods: {
    async openDialog(invoice) {
      this.selected = invoice
      this.amount = invoice.amount
      this.note = ""
      this.apiError = null
      this.dialog = true

      await this.loadMethods()

      this.selectedMethod = invoice.payment_method_id
      console.log(invoice)
    },

    // open fac
    openInvoice(invoice) {
        console.log
        window.open(`/back-office/factures/${invoice.id}`, '_blank')
    },

    canCancelForCorrection(invoice) {
      return invoice
        && invoice.serie === 'FA'
        && invoice.type === 'deposit'
        && !invoice.reference_invoice_id
        && !invoice.settlement_invoice_id
        && !this.hasStripePayment(invoice)
        && !this.invoices.some(candidate => (
          candidate.type === 'credit_note'
          && parseInt(candidate.reference_invoice_id, 10) === parseInt(invoice.id, 10)
        ))
    },

    hasStripePayment(invoice) {
      if (invoice.has_stripe_payment) return true

      return (invoice.payments || []).some(payment => (
        String(payment.payment_method?.name || '').trim().toLowerCase() === 'stripe'
        || !!payment.payment_intent_id
      ))
    },

    openCancelDialog(invoice) {
      this.selectedCancelInvoice = invoice
      this.cancelNote = ""
      this.cancelApiError = null
      this.cancelDialog = true
    },

    closeCancelDialog() {
      if (this.cancelLoading) return

      this.cancelDialog = false
      this.selectedCancelInvoice = null
      this.cancelNote = ""
      this.cancelApiError = null
    },

    async confirmCancelForCorrection() {
      if (!this.canConfirmCancel) return

      const invoice = this.selectedCancelInvoice
      this.cancellingInvoiceId = invoice.id
      this.cancelLoading = true
      this.cancelApiError = null

      try {
        const res = await axios.post('/back-office/caisse/invoices/cancel-for-correction', {
          invoice_id: invoice.id,
          note: this.cancelNote.trim(),
        })

        if (res.data?.checkout_url) {
          window.location.href = res.data.checkout_url
          return
        }

        window.location.reload()
      } catch (e) {
        this.cancelApiError = e?.response?.data?.message || "Impossible d'annuler cette facture."
      } finally {
        this.cancellingInvoiceId = null
        this.cancelLoading = false
      }
    },

    closeDialog() {
      this.dialog = false
      this.selected = null
      this.amount = null
      this.note = ""
      this.selectedMethod = null
      this.apiError = null
    },

    async loadMethods() {
      this.methodsLoading = true
      try {
        const res = await axios.get('/back-office/paiement-method/list')
        this.methods = (res.data || []).filter(method => !method.hidden)
      } catch (e) {
        this.apiError = "Impossible de charger les méthodes de paiement."
      } finally {
        this.methodsLoading = false
      }
    },

    async submit() {
      if (!this.canSubmit) return

      this.loading = true
      this.apiError = null
      console.log('im in');
      try {
        await axios.post('/back-office/caisse/errorOrderInvoice', {
          payment_id: this.selected.id, // id de la transaction
          method_id: this.selectedMethod, // new payment method
          original_payment_method_id: this.selected.payment_method_id, // id original
          amount: parseFloat(this.amount),
          note: this.note,
          update_order: false,
        })

        this.closeDialog()
        window.location.reload()
      } catch (e) {
        this.apiError =
          e?.response?.data?.message || "Une erreur est survenue."
      } finally {
        this.loading = false
      }
    },

    formatDate(date) {
      moment.locale('fr')
      return moment(date).format('DD/MM/YYYY HH:mm')
    },

    formatPrice(price) {
      const value = Math.abs(parseFloat(price || 0))
      return value.toFixed(2) + " €"
    }
                
  }
}
</script>

<style scoped>
.invoice-cancel-modal {
  border-radius: 4px;
  overflow: hidden;
}

.invoice-cancel-modal__header {
  padding: 1rem;
  border-bottom: 1px solid #e9ecef;
}

.invoice-cancel-modal__body {
  padding: 1rem;
}

.invoice-cancel-modal__footer {
  padding: .75rem;
  border-top: 1px solid #e9ecef;
}

.invoice-cancel-modal__summary {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
}

.invoice-cancel-modal__totals {
  min-width: 220px;
  font-size: .9em;
}

::v-deep .invoice-cancel-slide-y-transition-enter-active,
::v-deep .invoice-cancel-slide-y-transition-leave-active {
  transition: opacity .22s ease, transform .22s ease;
}

::v-deep .invoice-cancel-slide-y-transition-enter,
::v-deep .invoice-cancel-slide-y-transition-leave-to {
  opacity: 0;
  transform: translateY(-32px);
}

::v-deep .invoice-cancel-slide-y-transition-enter-to,
::v-deep .invoice-cancel-slide-y-transition-leave {
  opacity: 1;
  transform: translateY(0);
}
</style>
